/* =========================================================
   LC Base JS
   ==========
   Site-wide behaviors: scroll reveal.
   Loaded with `defer` from layout/theme.liquid so DOM is parsed
   before this runs. Direct port of Puddi base.js (Sample Scripts #3).
   ========================================================= */

(function () {
  'use strict';

  // Respect user preference — no reveal animation if reduced-motion is set.
  // (lc-base.css also forces .reveal visible under the same media query.)
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;

  // Reveal threshold: fire when 12% of the element has entered the viewport.
  var REVEAL_THRESHOLD = 0.12;

  if (!('IntersectionObserver' in window)) {
    // Very old browsers: just show everything.
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('on'); });
    return;
  }

  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('on');
        revealObserver.unobserve(entry.target); // animate once per pageload
      }
    });
  }, { threshold: REVEAL_THRESHOLD });

  document.querySelectorAll('.reveal').forEach(function (el) {
    revealObserver.observe(el);
  });
})();
